import { onMounted, ref } from 'vue'
import {
  detectSocialNetwork,
  getBrowserSessionStorage,
  readVisitorJourney,
  type SocialNetwork
} from '~/utils/visitorJourney'

/**
 * Social network the visitor arrived from (UTM, referrer or in-app browser),
 * read from the session journey. Resolved after mount so SSR and the first
 * client render stay identical (and cacheable); `null` until then.
 */
export const useSocialOrigin = () => {
  const network = ref<SocialNetwork | null>(null)

  onMounted(() => {
    const journey = readVisitorJourney(getBrowserSessionStorage())
    network.value = detectSocialNetwork({
      referrer: journey?.referrer,
      utm: journey?.utm,
      userAgent: navigator.userAgent
    }) || null
  })

  return { network }
}
